import Vue from "vue";
import Vuex from "vuex";
import Account from "./modules/account";
import Alert from "./modules/alert";
import Asset from "./modules/asset";
import Breadcrumb from "./modules/breadcrumb";
import Loading from "./modules/loading";
import LogIn from "./modules/logIn";
import Notification from "./modules/notification";
import Setting from "./modules/setting";
import Unit from "./modules/unit";
import Videofeedback from "./modules/videoFeedback";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    LogIn,
    Breadcrumb,
    Alert,
    Loading,
    Asset,
    Unit,
    Account,
    Notification,
    Setting,
    Videofeedback,
  },
  strict: true,
});

export default store;
